import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { DropdownMenu } from '@3plearning/react-components';
import { ALL_YEARS, YEAR_GROUP_LIST } from '../filter-constants';
import { dropdownItemPropType } from '../filter-prop-types';
import dropdownDataSelectors from '../redux/dropdown-data/dropdown-data-selectors';
import dropdownDataActions from '../redux/dropdown-data/dropdown-data-actions';
import {
    getTranslatedOptions,
    getTranslateSelectedOption
} from './dropdown-helpers';

export class YearGroupDropdown extends PureComponent {
    static propTypes = {
        yearGroupDropdownData: PropTypes.shape({
            data: PropTypes.arrayOf(dropdownItemPropType),
            selectedOption: dropdownItemPropType,
            disabled: PropTypes.bool
        }),
        className: PropTypes.string,
        setSelectedYearGroup: PropTypes.func,
        applyFilters: PropTypes.func.isRequired
    };

    render() {
        const {
            yearGroupDropdownData,
            className,
            setSelectedYearGroup,
            applyFilters
        } = this.props;
        const { data, selectedOption, disabled } = yearGroupDropdownData;
        const i18n = window.i18n;
        return (
            <DropdownMenu
                className={className}
                options={getTranslatedOptions(data, ALL_YEARS, i18n)}
                selectedOption={getTranslateSelectedOption(
                    selectedOption,
                    ALL_YEARS,
                    i18n
                )}
                onSelectOption={(e) => {
                    setSelectedYearGroup(e);
                    applyFilters();
                }}
                disabled={disabled}
            />
        );
    }
}

/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from CombinedReducers.
 */
function mapStateToProps(state) {
    return {
        yearGroupDropdownData: dropdownDataSelectors.selectDropdownDataByType(
            YEAR_GROUP_LIST
        )(state)
    };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        { setSelectedYearGroup: dropdownDataActions.setSelectedYearGroup },
        dispatch
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(YearGroupDropdown);



// WEBPACK FOOTER //
// ./components/report-filters/dropdown-menus/year-group-dropdown.js